import type { IconSvgObject } from './types';

const MusicThreeIcon: IconSvgObject = [
  ["circle", { cx: "18", cy: "16", r: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "6", cy: "18", r: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 18V6.63961C9 5.68625 9.67292 4.86542 10.6078 4.67845L18.8233 3.03534C18.9408 3.01184 19.0604 3 19.1802 3C20.1852 3 21 3.81475 21 4.8198V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MusicThreeIcon;
